// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import VueI18n from 'vue-i18n';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import App from './App';
import router from './router';
import store from './store';
import faConfig from './fa-config';
import messages from './i18n/global.i18n.json';
import { checkAuthenticated } from './utils/auth';
import { graphql } from './utils/fetch';

Vue.use(VueI18n);
Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: graphql,
});

const i18n = new VueI18n({
  locale: store.state.locale,
  messages,
});

Vue.use(Buefy, {
  defaultIconPack: 'fas',
  defaultToastDuration: 3000,
});

faConfig();
Vue.config.productionTip = false;

checkAuthenticated();

Vue.directive('focus', {
  inserted(el) {
    el.focus();
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App },
  provide: apolloProvider.provide(),
});



// WEBPACK FOOTER //
// ./src/main.js